import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { ClaimEntryStatus, GroupPolicyType } from 'src/app/utility/enum/global-enum';
import { EnumService } from 'src/app/utility/services/enum-service/enum.service';
import { AdditonalDocumentSubmissionMessage } from 'src/app/utility/services/message/custom-messages';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { GroupGlSubmissionService } from '../../../service/group-gl-submission/group-gl-submission.service';

@Component({
  selector: 'app-validate-claim-gl',
  templateUrl: './validate-claim-gl.component.html',
  styleUrls: ['./validate-claim-gl.component.scss']
})
export class ValidateClaimGlComponent implements OnInit {

  formDirectiveInputGeneration: FormGroupDirective;

  customMessage = new AdditonalDocumentSubmissionMessage();
  today = new Date();
  groupPolicyList: any[] = [];
  filteredGroupPolicyList: any[] = [];
  claimEntryList: any[] = [];
  filteredClaimEntryList: any[] = [];
  claimTypes: any[] = [];
  bancaDeathCauses: any[] = [];
  claimTypePrefixChanged:string;
  selectedPolicyId: number;
  selectedEnrolId: number;
  selectedEnrolDependentId: number;
  selectedClaimTypeId: number;
  groupPolicyId: number;
  claimEntryId: number;

  glSubmissionForm: FormGroup = this.fb.group({
    id: [0],
    groupPolicy: [null],
    groupPolicyId: [null, [Validators.required]],
    claimEntry: [null],
    claimNumber: [''],
    claimEntryId: [null, [Validators.required]],
    claimTypePrefix: [null, [Validators.required]],
    certificateNumber: ['', [Validators.required]],
    patientName: ['', [Validators.required]],
    enrolId: [null],
    enrolDependentId: [null],
    productName: [''],
    productId: ['', [Validators.required]],
  });

  @Output() onValidInput = new EventEmitter<any>();
  @Output() onParentChange = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private groupGlSubmissionService: GroupGlSubmissionService,
    private messageService: MessageService,
    private enumService: EnumService,
  ) { }

  ngOnInit() {
    this.getGlGroupPolicies();
    this.setSubscriber();
  }

  getGlGroupPolicies() {
    this.groupGlSubmissionService.getGlGroupPoliciesForHR(GroupPolicyType.Group).subscribe(
      res => {
        this.groupPolicyList = res;
        this.filteredGroupPolicyList = res;
      },
      err => {
        this.messageService.show(err.error.message, "error");
      });
  }

  groupPolicyChange(event: any) {
    if (event.value) {
      this.claimEntryList = this.filteredClaimEntryList = [];

      const groupPolicyId = event.value;
      this.groupGlSubmissionService.getHistoricalGlNigoClaims(groupPolicyId).subscribe(
        res => {
          this.claimEntryList = res;
          this.filteredClaimEntryList = res;

          this.glSubmissionForm.patchValue({
            groupPolicyId: groupPolicyId,
            claimEntry: null,
            claimNumber: null,
            claimEntryId: null,
            certificateNumber : null,
            patientName : null,
            enrolId: null,
            enrolDependentId: null,
            productName : null,
            productId: null,
          });

        },
        err => {
          this.messageService.show(err.error.message, "error");
        });

    }
  }

  setSubscriber() {

      this.glSubmissionForm.controls['claimEntry'].valueChanges
      .pipe(debounceTime(10))
      .subscribe(c => {

        if (c && typeof (c) == 'string') {

          this.glSubmissionForm.patchValue({
            claimEntryId: null,
            certificateNumber : null,
            patientName : null,
            enrolId: null,
            enrolDependentId: null,
            productName : null,
            productId: null,
          });

          this.filteredClaimEntryList = this.claimEntryList.filter(x => x.claimNumber.toLowerCase().
            includes(c.toLowerCase()));

        } else {
          this.filteredClaimEntryList = this.claimEntryList;

        }
      });

  }

  onClaimEntryChanged = (event: any): void => {

    if (event.option.value) {
      let selectedClaimEntry: any = event.option.value;

      this.glSubmissionForm.patchValue({
        claimTypePrefix: selectedClaimEntry.claimTypePrefix,
        claimEntryId: selectedClaimEntry.claimEntryId,
        patientName : selectedClaimEntry.patientName,
        enrolId: selectedClaimEntry.enrolId,
        enrolDependentId: selectedClaimEntry.enrolDependentId,
        certificateNumber : selectedClaimEntry.certificateNumber,
        productName : selectedClaimEntry.productName,
        productId: selectedClaimEntry.productId,
      });
    }
  }


  validateClaimEntryInput() {
    const entity = this.glSubmissionForm.getRawValue();

    if (!entity.claimEntry) {
      this.glSubmissionForm.patchValue({
        claimEntry: null,
        claimNumber: null,
        claimEntryId: null,
        certificateNumber : null,
        patientName : null,
        enrolId: null,
        enrolDependentId: null,
        productName : null,
        productId: null,
      });
      this.glSubmissionForm.updateValueAndValidity();
    }

  }

  displayClaimNumber = (claimEntry: any): string => {
    let claimNumber: string = '';
    if (claimEntry && claimEntry.claimNumber) {
      claimNumber = claimEntry.claimNumber;
    }
    return claimNumber;
  }

  resetFrom(formDirective: FormGroupDirective) {
    if (formDirective != null) {
      formDirective.resetForm();
    }
    this.glSubmissionForm.reset(
      {
        id: 0,
      }
    );
  }

  goToUploadDocument() {
   const formData = this.glSubmissionForm.getRawValue();
   const statusId = this.claimEntryList.find(x => x.claimEntryId == formData.claimEntryId).statusId;
   if(statusId == ClaimEntryStatus.SendToNIGOAdjudicationQueue
      || statusId == ClaimEntryStatus.SendToNIGOPaymentQueue
      || statusId == ClaimEntryStatus.SendToNIGOMedicalAdvisorQueue
      || statusId == ClaimEntryStatus.SendToNigoPartialPaymentQueue
    ) {
      this.notifyParentComponent(formData);
    } else {
      this.messageService.show(this.customMessage.notInNIGOQueueMessage, "warning");
    }

  }

  notifyParentComponent(formData: any) {

    if((this.groupPolicyId != formData.groupPolicyId) || (this.claimEntryId != formData.claimEntryId)){
      this.onParentChange.emit(true);
    }
    else{
      this.onParentChange.emit(false);
    }

    this.groupPolicyId = formData.groupPolicyId;
    this.claimEntryId = formData.claimEntryId;

    const data = {
      claimEntryId: formData.claimEntryId,
      claimTypePrefix: formData.claimTypePrefix,
      patientName: formData.patientName
    }
    this.onValidInput.emit(data);

  }

  resetFromSettings() {
    if (this.formDirectiveInputGeneration != null) {
      this.formDirectiveInputGeneration.resetForm();
    }
    this.glSubmissionForm.reset({ id: 0 });
    this.groupPolicyId = this.claimEntryId = 0;
  }

}

